import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import { AuthProvider } from "./hooks/useAuth";
import { useMessage } from './hooks/useMessage';
import { MessageContainer } from './components/twui/Message';
import { ErrorBoundary } from './components/feature/ErrorBoundary';
import VersionUpdateModal from './components/feature/VersionUpdateModal';
import ForcePasswordChangeModal from './components/feature/ForcePasswordChangeModal';

function App() {
  const { messages, removeMessage } = useMessage();
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename="/">
          <MessageContainer messages={messages} removeMessage={removeMessage} />
          <Navbar />
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
          {/* 版本更新确认弹框：新版本发布后切换页面触发 */}
          <VersionUpdateModal />
          {/* 强制修改密码弹框：首次登录 mustChangePwd === '1' 时触发 */}
          <ForcePasswordChangeModal />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;